import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const GolfBagIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "GolfBagIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5127 14.4494C9.5127 13.8142 10.0073 13.2993 10.6174 13.2993H12.0904C12.7005 13.2993 13.1951 13.8142 13.1951 14.4494V18.283C13.1951 18.9182 12.7005 19.4331 12.0904 19.4331H10.6174C10.0073 19.4331 9.5127 18.9182 9.5127 18.283V14.4494ZM10.6174 14.066C10.4141 14.066 10.2492 14.2376 10.2492 14.4494V15.2161H12.4586V14.4494C12.4586 14.2376 12.2938 14.066 12.0904 14.066H10.6174ZM12.4586 15.9828H10.2492V18.283C10.2492 18.4947 10.4141 18.6664 10.6174 18.6664H12.0904C12.2938 18.6664 12.4586 18.4947 12.4586 18.283V15.9828Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.5127 10.2323C9.30932 10.2323 9.14445 10.404 9.14445 10.6157C9.14445 10.8274 9.30932 10.9991 9.5127 10.9991H13.1951C13.3985 10.9991 13.5634 10.8274 13.5634 10.6157C13.5634 10.404 13.3985 10.2323 13.1951 10.2323H9.5127Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7679 4.54957L8.97738 4.5213C8.16097 4.50841 7.5155 3.79711 7.54953 2.94782C7.5839 2.09007 8.2971 1.4345 9.11893 1.50523L9.72133 1.55707C10.6121 1.63374 11.3213 2.36533 11.4031 3.29193L11.4784 4.14411L11.7661 8.31552H12.5553L13.585 4.83177C13.8478 3.94242 14.6863 3.37805 15.5732 3.49347L16.1729 3.57152C16.9912 3.678 17.5599 4.47208 17.4243 5.3189C17.2901 6.15736 16.5181 6.7155 15.7165 6.55357L13.952 6.19709L13.3259 8.31552H13.5634C14.3769 8.31552 15.0363 9.00208 15.0363 9.84898V10.6157C15.0364 11.198 15.2084 12.2077 15.5678 13.2675C15.927 14.3271 16.4563 15.3853 17.1381 16.0951C18.0849 17.0808 18.2069 18.2305 17.7221 19.1112C17.2506 19.9678 16.2501 20.4807 15.1354 20.3226C15.1014 20.3177 15.0684 20.3112 15.0363 20.3031V20.5832C15.0363 21.2988 14.5655 21.8999 13.9288 22.0691C13.9307 22.0847 13.9316 22.1005 13.9316 22.1166C13.9316 22.3284 13.7667 22.5 13.5634 22.5H9.14445C8.94108 22.5 8.77621 22.3284 8.77621 22.1166C8.77621 22.1005 8.77717 22.0847 8.77902 22.0691C8.14229 21.8999 7.67148 21.2988 7.67148 20.5832V20.0403C7.0212 19.7445 6.56675 19.069 6.56675 18.283V15.9828C6.56675 15.1968 7.0212 14.5213 7.67148 14.2255V9.84898C7.67148 9.00208 8.33095 8.31552 9.14445 8.31552H9.75795L9.48733 7.34819L7.7278 7.70366C6.92626 7.86559 6.15423 7.30745 6.02 6.46899C5.88443 5.62217 6.4531 4.82809 7.27137 4.72161L7.87116 4.64356C8.75805 4.52814 9.59647 5.09251 9.85933 5.98187L10.1005 6.79801L10.525 8.31552H11.0277L10.7679 4.54957ZM10.6697 3.36211C10.6206 2.80615 10.1951 2.36719 9.66065 2.3212L9.05825 2.26935C8.65353 2.23452 8.30231 2.55736 8.28538 2.97978C8.26862 3.39802 8.58649 3.74831 8.98854 3.75466L10.7068 3.78178L10.6697 3.36211ZM14.2999 9.84898C14.2999 9.42553 13.9701 9.08225 13.5634 9.08225H9.14445C8.7377 9.08225 8.40797 9.42553 8.40797 9.84898V20.5832C8.40797 21.0066 8.7377 21.3499 9.14445 21.3499H13.5634C13.9701 21.3499 14.2999 21.0066 14.2999 20.5832V9.84898ZM7.67148 19.1402V15.1256C7.44547 15.3362 7.30324 15.6422 7.30324 15.9828V18.283C7.30324 18.6236 7.44547 18.9296 7.67148 19.1402ZM15.4818 4.25427C14.9497 4.18502 14.4466 4.52365 14.2889 5.05726L14.1699 5.46007L15.8568 5.80088C16.2515 5.88063 16.6317 5.60576 16.6978 5.19285C16.7646 4.77582 16.4846 4.38476 16.0816 4.33232L15.4818 4.25427ZM9.15541 6.20735C8.9977 5.67374 8.49465 5.33512 7.96251 5.40437L7.36272 5.48242C6.95975 5.53486 6.6797 5.92591 6.74646 6.34294C6.81257 6.75585 7.19277 7.03072 7.5875 6.95097L9.27446 6.61016L9.15541 6.20735ZM15.0365 19.2638L15.0364 13.9744C15.4094 14.9461 15.9326 15.9244 16.6173 16.6373C17.3657 17.4164 17.3781 18.1941 17.0831 18.73C16.7749 19.29 16.0815 19.6829 15.2348 19.5628C15.1445 19.55 15.0365 19.449 15.0365 19.2638Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default GolfBagIcon;
